import axios from 'src/api/Api';
import {
    SUBMIT_PROCEDURE_DATA_SUCCESS,
    SUBMIT_PROCEDURE_DATA_FAILURE,
    RESET_SUBMIT_PROCEDURE_DATA,
} from 'src/pages/orders/redux/actions';
import { put, delay } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* submitProcedureData(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/equity/submitEquityProcedure`;

    try {
        const result = yield axios
            .put(url, action.payload)
            .then((response) => response.data);
        yield put({ type: SUBMIT_PROCEDURE_DATA_SUCCESS, data: result });
        yield delay(1500);
        yield put({ type: RESET_SUBMIT_PROCEDURE_DATA });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SUBMIT_PROCEDURE_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
